const n=Symbol("solana-funding-plugin");export{n as SOLANA_FUNDING_PLUGIN_ID};
